"use strict";
'use client';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var MainTemplateErrorBoundary = /** @class */ (function (_super) {
    __extends(MainTemplateErrorBoundary, _super);
    function MainTemplateErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
            error: null,
            componentStack: null,
        };
        _this.handleReset = function () {
            _this.setState({ hasError: false, error: null, componentStack: null });
        };
        return _this;
    }
    MainTemplateErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    MainTemplateErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _a, _b;
        if (this.state.componentStack !== errorInfo.componentStack) {
            this.setState({ componentStack: errorInfo.componentStack });
        }
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, errorInfo);
    };
    MainTemplateErrorBoundary.prototype.render = function () {
        if (!this.state.hasError)
            return this.props.children;
        if (this.props.fallback)
            return this.props.fallback;
        return (react_1.default.createElement("div", { style: { padding: 20, textAlign: 'center' } },
            react_1.default.createElement("h3", { style: { color: '#fff' } }, "Something went wrong"),
            react_1.default.createElement("br", null),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "100%", maxWidth: "100%", text: "upper", onClick: function () { return window.location.reload(); } }, "Refresh Page"),
            react_1.default.createElement("br", null),
            react_1.default.createElement(ui_components_1.FixedButton, { variant: "outline", width: "100%", maxWidth: "100%", text: "upper", onClick: this.handleReset }, "Try Again")));
    };
    return MainTemplateErrorBoundary;
}(react_1.Component));
exports.default = MainTemplateErrorBoundary;
